/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


export const PortfoliosListQueryParams = zod.object({
  "portfolio": zod.array(zod.string()).optional(),
  "query": zod.string().optional(),
  "region": zod.array(zod.string()).optional(),
  "service_provider": zod.array(zod.string()).optional()
})

export const portfoliosListResponseClientOneOwnerOneUsernameMax = 150;


export const portfoliosListResponseClientOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosListResponseClientOneOwnerOneEmailMax = 254;

export const portfoliosListResponseClientOneOwnerOnePhoneNumberMax = 128;

export const portfoliosListResponsePropertiesItemRegionMax = 255;

export const portfoliosListResponsePropertiesItemConsultantGroupOneOwnerOneUsernameMax = 150;


export const portfoliosListResponsePropertiesItemConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosListResponsePropertiesItemConsultantGroupOneOwnerOneEmailMax = 254;

export const portfoliosListResponsePropertiesItemConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const portfoliosListResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameMax = 150;


export const portfoliosListResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosListResponsePropertiesItemConsultantGroupOneConsultantsItemEmailMax = 254;

export const portfoliosListResponsePropertiesItemConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const portfoliosListResponsePropertiesItemConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const portfoliosListResponsePropertiesItemAssignedConsultantOneUsernameMax = 150;


export const portfoliosListResponsePropertiesItemAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosListResponsePropertiesItemAssignedConsultantOneEmailMax = 254;

export const portfoliosListResponsePropertiesItemAssignedConsultantOnePhoneNumberMax = 128;

export const portfoliosListResponsePropertiesItemPropertyManagerOneOwnerOneUsernameMax = 150;


export const portfoliosListResponsePropertiesItemPropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosListResponsePropertiesItemPropertyManagerOneOwnerOneEmailMax = 254;

export const portfoliosListResponsePropertiesItemPropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const portfoliosListResponsePropertiesItemBuildingNumberMax = 255;

export const portfoliosListResponsePropertiesItemContactOneNameMax = 255;



export const PortfoliosListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "client": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosListResponseClientOneOwnerOneUsernameMax).regex(portfoliosListResponseClientOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosListResponseClientOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosListResponseClientOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "properties": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "serviceProviders": zod.array(zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "region": zod.string().max(portfoliosListResponsePropertiesItemRegionMax).nullish(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosListResponsePropertiesItemConsultantGroupOneOwnerOneUsernameMax).regex(portfoliosListResponsePropertiesItemConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(portfoliosListResponsePropertiesItemConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosListResponsePropertiesItemConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosListResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameMax).regex(portfoliosListResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(portfoliosListResponsePropertiesItemConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosListResponsePropertiesItemConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(portfoliosListResponsePropertiesItemConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosListResponsePropertiesItemAssignedConsultantOneUsernameMax).regex(portfoliosListResponsePropertiesItemAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosListResponsePropertiesItemAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosListResponsePropertiesItemAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosListResponsePropertiesItemPropertyManagerOneOwnerOneUsernameMax).regex(portfoliosListResponsePropertiesItemPropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosListResponsePropertiesItemPropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosListResponsePropertiesItemPropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "buildingNumber": zod.string().max(portfoliosListResponsePropertiesItemBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(portfoliosListResponsePropertiesItemContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'))
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')
export const PortfoliosListResponse = zod.array(PortfoliosListResponseItem)




export const PortfoliosCreateBody = zod.object({
  "name": zod.string().min(1)
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const portfoliosCreateResponseClientOneOwnerOneUsernameMax = 150;


export const portfoliosCreateResponseClientOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosCreateResponseClientOneOwnerOneEmailMax = 254;

export const portfoliosCreateResponseClientOneOwnerOnePhoneNumberMax = 128;

export const portfoliosCreateResponsePropertiesItemRegionMax = 255;

export const portfoliosCreateResponsePropertiesItemConsultantGroupOneOwnerOneUsernameMax = 150;


export const portfoliosCreateResponsePropertiesItemConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosCreateResponsePropertiesItemConsultantGroupOneOwnerOneEmailMax = 254;

export const portfoliosCreateResponsePropertiesItemConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const portfoliosCreateResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameMax = 150;


export const portfoliosCreateResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosCreateResponsePropertiesItemConsultantGroupOneConsultantsItemEmailMax = 254;

export const portfoliosCreateResponsePropertiesItemConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const portfoliosCreateResponsePropertiesItemConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const portfoliosCreateResponsePropertiesItemAssignedConsultantOneUsernameMax = 150;


export const portfoliosCreateResponsePropertiesItemAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosCreateResponsePropertiesItemAssignedConsultantOneEmailMax = 254;

export const portfoliosCreateResponsePropertiesItemAssignedConsultantOnePhoneNumberMax = 128;

export const portfoliosCreateResponsePropertiesItemPropertyManagerOneOwnerOneUsernameMax = 150;


export const portfoliosCreateResponsePropertiesItemPropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosCreateResponsePropertiesItemPropertyManagerOneOwnerOneEmailMax = 254;

export const portfoliosCreateResponsePropertiesItemPropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const portfoliosCreateResponsePropertiesItemBuildingNumberMax = 255;

export const portfoliosCreateResponsePropertiesItemContactOneNameMax = 255;



export const PortfoliosCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "client": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosCreateResponseClientOneOwnerOneUsernameMax).regex(portfoliosCreateResponseClientOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosCreateResponseClientOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosCreateResponseClientOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "properties": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "serviceProviders": zod.array(zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "region": zod.string().max(portfoliosCreateResponsePropertiesItemRegionMax).nullish(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosCreateResponsePropertiesItemConsultantGroupOneOwnerOneUsernameMax).regex(portfoliosCreateResponsePropertiesItemConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(portfoliosCreateResponsePropertiesItemConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosCreateResponsePropertiesItemConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosCreateResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameMax).regex(portfoliosCreateResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(portfoliosCreateResponsePropertiesItemConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosCreateResponsePropertiesItemConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(portfoliosCreateResponsePropertiesItemConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosCreateResponsePropertiesItemAssignedConsultantOneUsernameMax).regex(portfoliosCreateResponsePropertiesItemAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosCreateResponsePropertiesItemAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosCreateResponsePropertiesItemAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosCreateResponsePropertiesItemPropertyManagerOneOwnerOneUsernameMax).regex(portfoliosCreateResponsePropertiesItemPropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosCreateResponsePropertiesItemPropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosCreateResponsePropertiesItemPropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "buildingNumber": zod.string().max(portfoliosCreateResponsePropertiesItemBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(portfoliosCreateResponsePropertiesItemContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'))
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const PortfoliosRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this portfolio.')
})

export const portfoliosRetrieveResponseClientOneOwnerOneUsernameMax = 150;


export const portfoliosRetrieveResponseClientOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosRetrieveResponseClientOneOwnerOneEmailMax = 254;

export const portfoliosRetrieveResponseClientOneOwnerOnePhoneNumberMax = 128;

export const portfoliosRetrieveResponsePropertiesItemRegionMax = 255;

export const portfoliosRetrieveResponsePropertiesItemConsultantGroupOneOwnerOneUsernameMax = 150;


export const portfoliosRetrieveResponsePropertiesItemConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosRetrieveResponsePropertiesItemConsultantGroupOneOwnerOneEmailMax = 254;

export const portfoliosRetrieveResponsePropertiesItemConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const portfoliosRetrieveResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameMax = 150;


export const portfoliosRetrieveResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosRetrieveResponsePropertiesItemConsultantGroupOneConsultantsItemEmailMax = 254;

export const portfoliosRetrieveResponsePropertiesItemConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const portfoliosRetrieveResponsePropertiesItemConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const portfoliosRetrieveResponsePropertiesItemAssignedConsultantOneUsernameMax = 150;


export const portfoliosRetrieveResponsePropertiesItemAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosRetrieveResponsePropertiesItemAssignedConsultantOneEmailMax = 254;

export const portfoliosRetrieveResponsePropertiesItemAssignedConsultantOnePhoneNumberMax = 128;

export const portfoliosRetrieveResponsePropertiesItemPropertyManagerOneOwnerOneUsernameMax = 150;


export const portfoliosRetrieveResponsePropertiesItemPropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosRetrieveResponsePropertiesItemPropertyManagerOneOwnerOneEmailMax = 254;

export const portfoliosRetrieveResponsePropertiesItemPropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const portfoliosRetrieveResponsePropertiesItemBuildingNumberMax = 255;

export const portfoliosRetrieveResponsePropertiesItemContactOneNameMax = 255;



export const PortfoliosRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "client": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosRetrieveResponseClientOneOwnerOneUsernameMax).regex(portfoliosRetrieveResponseClientOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosRetrieveResponseClientOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosRetrieveResponseClientOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "properties": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "serviceProviders": zod.array(zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "region": zod.string().max(portfoliosRetrieveResponsePropertiesItemRegionMax).nullish(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosRetrieveResponsePropertiesItemConsultantGroupOneOwnerOneUsernameMax).regex(portfoliosRetrieveResponsePropertiesItemConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(portfoliosRetrieveResponsePropertiesItemConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosRetrieveResponsePropertiesItemConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosRetrieveResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameMax).regex(portfoliosRetrieveResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(portfoliosRetrieveResponsePropertiesItemConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosRetrieveResponsePropertiesItemConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(portfoliosRetrieveResponsePropertiesItemConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosRetrieveResponsePropertiesItemAssignedConsultantOneUsernameMax).regex(portfoliosRetrieveResponsePropertiesItemAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosRetrieveResponsePropertiesItemAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosRetrieveResponsePropertiesItemAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosRetrieveResponsePropertiesItemPropertyManagerOneOwnerOneUsernameMax).regex(portfoliosRetrieveResponsePropertiesItemPropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosRetrieveResponsePropertiesItemPropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosRetrieveResponsePropertiesItemPropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "buildingNumber": zod.string().max(portfoliosRetrieveResponsePropertiesItemBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(portfoliosRetrieveResponsePropertiesItemContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'))
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const PortfoliosUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this portfolio.')
})




export const PortfoliosUpdateBody = zod.object({
  "name": zod.string().min(1)
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const portfoliosUpdateResponseClientOneOwnerOneUsernameMax = 150;


export const portfoliosUpdateResponseClientOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosUpdateResponseClientOneOwnerOneEmailMax = 254;

export const portfoliosUpdateResponseClientOneOwnerOnePhoneNumberMax = 128;

export const portfoliosUpdateResponsePropertiesItemRegionMax = 255;

export const portfoliosUpdateResponsePropertiesItemConsultantGroupOneOwnerOneUsernameMax = 150;


export const portfoliosUpdateResponsePropertiesItemConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosUpdateResponsePropertiesItemConsultantGroupOneOwnerOneEmailMax = 254;

export const portfoliosUpdateResponsePropertiesItemConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const portfoliosUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameMax = 150;


export const portfoliosUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemEmailMax = 254;

export const portfoliosUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const portfoliosUpdateResponsePropertiesItemConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const portfoliosUpdateResponsePropertiesItemAssignedConsultantOneUsernameMax = 150;


export const portfoliosUpdateResponsePropertiesItemAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosUpdateResponsePropertiesItemAssignedConsultantOneEmailMax = 254;

export const portfoliosUpdateResponsePropertiesItemAssignedConsultantOnePhoneNumberMax = 128;

export const portfoliosUpdateResponsePropertiesItemPropertyManagerOneOwnerOneUsernameMax = 150;


export const portfoliosUpdateResponsePropertiesItemPropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosUpdateResponsePropertiesItemPropertyManagerOneOwnerOneEmailMax = 254;

export const portfoliosUpdateResponsePropertiesItemPropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const portfoliosUpdateResponsePropertiesItemBuildingNumberMax = 255;

export const portfoliosUpdateResponsePropertiesItemContactOneNameMax = 255;



export const PortfoliosUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "client": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosUpdateResponseClientOneOwnerOneUsernameMax).regex(portfoliosUpdateResponseClientOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosUpdateResponseClientOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosUpdateResponseClientOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "properties": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "serviceProviders": zod.array(zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "region": zod.string().max(portfoliosUpdateResponsePropertiesItemRegionMax).nullish(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosUpdateResponsePropertiesItemConsultantGroupOneOwnerOneUsernameMax).regex(portfoliosUpdateResponsePropertiesItemConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(portfoliosUpdateResponsePropertiesItemConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosUpdateResponsePropertiesItemConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameMax).regex(portfoliosUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(portfoliosUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(portfoliosUpdateResponsePropertiesItemConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosUpdateResponsePropertiesItemAssignedConsultantOneUsernameMax).regex(portfoliosUpdateResponsePropertiesItemAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosUpdateResponsePropertiesItemAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosUpdateResponsePropertiesItemAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosUpdateResponsePropertiesItemPropertyManagerOneOwnerOneUsernameMax).regex(portfoliosUpdateResponsePropertiesItemPropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosUpdateResponsePropertiesItemPropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosUpdateResponsePropertiesItemPropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "buildingNumber": zod.string().max(portfoliosUpdateResponsePropertiesItemBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(portfoliosUpdateResponsePropertiesItemContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'))
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const PortfoliosPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this portfolio.')
})




export const PortfoliosPartialUpdateBody = zod.object({
  "name": zod.string().min(1).optional()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const portfoliosPartialUpdateResponseClientOneOwnerOneUsernameMax = 150;


export const portfoliosPartialUpdateResponseClientOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosPartialUpdateResponseClientOneOwnerOneEmailMax = 254;

export const portfoliosPartialUpdateResponseClientOneOwnerOnePhoneNumberMax = 128;

export const portfoliosPartialUpdateResponsePropertiesItemRegionMax = 255;

export const portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneOwnerOneUsernameMax = 150;


export const portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneOwnerOneEmailMax = 254;

export const portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameMax = 150;


export const portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemEmailMax = 254;

export const portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const portfoliosPartialUpdateResponsePropertiesItemAssignedConsultantOneUsernameMax = 150;


export const portfoliosPartialUpdateResponsePropertiesItemAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosPartialUpdateResponsePropertiesItemAssignedConsultantOneEmailMax = 254;

export const portfoliosPartialUpdateResponsePropertiesItemAssignedConsultantOnePhoneNumberMax = 128;

export const portfoliosPartialUpdateResponsePropertiesItemPropertyManagerOneOwnerOneUsernameMax = 150;


export const portfoliosPartialUpdateResponsePropertiesItemPropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const portfoliosPartialUpdateResponsePropertiesItemPropertyManagerOneOwnerOneEmailMax = 254;

export const portfoliosPartialUpdateResponsePropertiesItemPropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const portfoliosPartialUpdateResponsePropertiesItemBuildingNumberMax = 255;

export const portfoliosPartialUpdateResponsePropertiesItemContactOneNameMax = 255;



export const PortfoliosPartialUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "client": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosPartialUpdateResponseClientOneOwnerOneUsernameMax).regex(portfoliosPartialUpdateResponseClientOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosPartialUpdateResponseClientOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosPartialUpdateResponseClientOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "properties": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "serviceProviders": zod.array(zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "region": zod.string().max(portfoliosPartialUpdateResponsePropertiesItemRegionMax).nullish(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneOwnerOneUsernameMax).regex(portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameMax).regex(portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(portfoliosPartialUpdateResponsePropertiesItemConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosPartialUpdateResponsePropertiesItemAssignedConsultantOneUsernameMax).regex(portfoliosPartialUpdateResponsePropertiesItemAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosPartialUpdateResponsePropertiesItemAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosPartialUpdateResponsePropertiesItemAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(portfoliosPartialUpdateResponsePropertiesItemPropertyManagerOneOwnerOneUsernameMax).regex(portfoliosPartialUpdateResponsePropertiesItemPropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(portfoliosPartialUpdateResponsePropertiesItemPropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(portfoliosPartialUpdateResponsePropertiesItemPropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "buildingNumber": zod.string().max(portfoliosPartialUpdateResponsePropertiesItemBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(portfoliosPartialUpdateResponsePropertiesItemContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'))
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const PortfoliosDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this portfolio.')
})

export const PortfoliosDestroyResponse = zod.void()

export const PortfoliosKpisRetrieveQueryParams = zod.object({
  "end_date": zod.string().optional(),
  "period": zod.string().optional().describe('Pass ``all`` to report over the full history of the scoped properties, resolved from the earliest ticket or invoice rather than a trailing window. Overrides start_date\/end_date. The window actually used comes back in ``resolvedRange``.'),
  "portfolio": zod.array(zod.string()).optional(),
  "property": zod.array(zod.string()).optional(),
  "region": zod.array(zod.string()).optional(),
  "service_provider": zod.array(zod.string()).optional(),
  "start_date": zod.string().optional()
})

export const portfoliosKpisRetrieveResponseSummaryMaintenanceTotalAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const portfoliosKpisRetrieveResponseSummarySpendingRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const portfoliosKpisRetrieveResponseByDateItemMaintenanceTotalAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const portfoliosKpisRetrieveResponseByDateItemSpendingRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const portfoliosKpisRetrieveResponseByPropertyItemMaintenanceTotalAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const portfoliosKpisRetrieveResponseByPropertyItemSpendingRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const portfoliosKpisRetrieveResponseByContractItemMaintenanceTotalAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const portfoliosKpisRetrieveResponseByContractItemSpendingRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');


export const PortfoliosKpisRetrieveResponse = zod.object({
  "summary": zod.object({
  "date": zod.string().date(),
  "avgCallResponseTimeSecs": zod.number(),
  "meanTimeBetweenCallbacks": zod.number(),
  "callbackRate": zod.number(),
  "callbacks": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "emergencyCalls": zod.number(),
  "maintenanceCompletion": zod.number(),
  "maintenanceHours": zod.number(),
  "maintenanceVisit": zod.number(),
  "maintenanceTotalAmount": zod.string().regex(portfoliosKpisRetrieveResponseSummaryMaintenanceTotalAmountRegExp),
  "spending": zod.string().regex(portfoliosKpisRetrieveResponseSummarySpendingRegExp),
  "onTimeResponse": zod.number()
}).strict(),
  "charts": zod.object({
  "ticketsByType": zod.object({
  "total": zod.number(),
  "data": zod.array(zod.array(zod.union([zod.string(),zod.number()])))
}).strict(),
  "spendingsByType": zod.object({
  "invoice": zod.object({
  "total": zod.number(),
  "data": zod.array(zod.array(zod.union([zod.string(),zod.number()])))
}).strict(),
  "totalInvoicesNum": zod.number(),
  "proposal": zod.object({
  "total": zod.number(),
  "data": zod.array(zod.array(zod.union([zod.string(),zod.number()])))
}).strict(),
  "totalProposalsNum": zod.number()
}).strict(),
  "savingsByType": zod.object({
  "invoice": zod.object({
  "total": zod.number(),
  "data": zod.array(zod.array(zod.union([zod.string(),zod.number()])))
}).strict(),
  "totalInvoicesNum": zod.number(),
  "proposal": zod.object({
  "total": zod.number(),
  "data": zod.array(zod.array(zod.union([zod.string(),zod.number()])))
}).strict(),
  "totalProposalsNum": zod.number()
}).strict()
}).strict(),
  "byDate": zod.array(zod.object({
  "date": zod.string().date(),
  "avgCallResponseTimeSecs": zod.number(),
  "meanTimeBetweenCallbacks": zod.number(),
  "callbackRate": zod.number(),
  "callbacks": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "emergencyCalls": zod.number(),
  "maintenanceCompletion": zod.number(),
  "maintenanceHours": zod.number(),
  "maintenanceVisit": zod.number(),
  "maintenanceTotalAmount": zod.string().regex(portfoliosKpisRetrieveResponseByDateItemMaintenanceTotalAmountRegExp),
  "spending": zod.string().regex(portfoliosKpisRetrieveResponseByDateItemSpendingRegExp),
  "onTimeResponse": zod.number()
}).strict()),
  "byProperty": zod.array(zod.object({
  "avgCallResponseTimeSecs": zod.number(),
  "meanTimeBetweenCallbacks": zod.number(),
  "callbackRate": zod.number(),
  "callbacks": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "emergencyCalls": zod.number(),
  "maintenanceCompletion": zod.number(),
  "maintenanceHours": zod.number(),
  "maintenanceVisit": zod.number(),
  "maintenanceTotalAmount": zod.string().regex(portfoliosKpisRetrieveResponseByPropertyItemMaintenanceTotalAmountRegExp),
  "spending": zod.string().regex(portfoliosKpisRetrieveResponseByPropertyItemSpendingRegExp),
  "onTimeResponse": zod.number(),
  "property": zod.string().uuid(),
  "propertyName": zod.string().optional()
}).strict().describe('One row per property. Optionally enriched with the property\'s\nname via context (so callers like the chat render_metric_set\nperformance-table can label rows with names rather than UUIDs).\nPass `name_by_property={property_id: name}` in the parent\nserializer\'s context.')),
  "byContract": zod.array(zod.object({
  "avgCallResponseTimeSecs": zod.number(),
  "meanTimeBetweenCallbacks": zod.number(),
  "callbackRate": zod.number(),
  "callbacks": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "emergencyCalls": zod.number(),
  "maintenanceCompletion": zod.number(),
  "maintenanceHours": zod.number(),
  "maintenanceVisit": zod.number(),
  "maintenanceTotalAmount": zod.string().regex(portfoliosKpisRetrieveResponseByContractItemMaintenanceTotalAmountRegExp),
  "spending": zod.string().regex(portfoliosKpisRetrieveResponseByContractItemSpendingRegExp),
  "onTimeResponse": zod.number(),
  "contract": zod.string().uuid(),
  "serviceProvider": zod.object({
  "id": zod.string(),
  "name": zod.string()
}).strict().optional()
}).strict().describe('One row per contract. Optionally enriched with the contract\'s\nservice_provider via context (so callers like the chat\nrender_vendor_cards tool can group by vendor without a second API\nround-trip). Pass `service_provider_by_contract={contract_id: {id, name}}`\nin the parent serializer\'s context.')),
  "byServiceProvider": zod.array(zod.object({
  "serviceProvider": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "callbacks": zod.number().describe('Callback tickets (regular, deferred and emergency) this provider logged.'),
  "emergencyCalls": zod.number().describe('The emergency subset of `callbacks`.'),
  "maintenanceVisits": zod.number().describe('Maintenance visit tickets this provider logged.'),
  "onTimeResponse": zod.number().nullable().describe('Fraction 0-1 of this provider\'s callback tickets where work started within every serviced car\'s contracted response time. Null when the provider logged no callbacks.')
}).strict().describe('One row per service provider that logged a ticket in the window, with\nfigures for the tickets it logged.\n\nNot the same question `byContract` answers. A contract row counts only\ntickets on cars assigned to that contract, so a vendor\'s callbacks at a\nproperty where it holds no contract appear on no contract row. These\nrows count every ticket by the provider named on it, over the same\ntickets as `summary`, so `callbacks` summed across rows (including the\nrow with a null `serviceProvider`, for tickets that name none) equals\n`summary.callbacks`.\n\nNo callback rate per car: there is no per-vendor car count to divide\nby. `onTimeResponse` is the one rate, and it needs no car count.')),
  "targetComplianceByProperty": zod.array(zod.object({
  "property": zod.string().uuid(),
  "hasData": zod.boolean(),
  "belowMaintenanceTarget": zod.boolean(),
  "belowOnTimeResponseTarget": zod.boolean(),
  "overCallbackRateTarget": zod.boolean(),
  "overEmergencyCallbackRateTarget": zod.boolean()
}).strict().describe('One row per property: whether it is meeting the targets its contracts set.\n\nSeparate from `KPIPropertySerializer` rather than folded into it because the\ntwo answer different questions from different sources — that one reports\nmeasured values, this one compares them against `PropertyContractCar`\ntargets that vary per elevator. Keeping them apart also leaves the existing\n`byProperty` payload untouched.\n\nEach flag means \"at least one elevator at this property missed its own\ncontracted target\", matching how `maintenance_completion` is already\nderived. `has_data` is False when the window reported nothing, in which case\nevery flag is False rather than the zeroes reading as total failure.')),
  "resolvedRange": zod.object({
  "allTime": zod.boolean(),
  "clamped": zod.boolean(),
  "emptyScope": zod.boolean(),
  "resolvedStart": zod.string(),
  "resolvedEnd": zod.string()
}).strict().describe('The date window the response was actually computed over.\n\nEchoed back because `?period=all` resolves its lower bound server-side\nfrom the scope\'s earliest ticket\/invoice — the caller can\'t know it up\nfront, and a clamped window must never be presented to a user as\n\"all time\".')
}).strict()

export const PortfoliosPendingDataRetrieveQueryParams = zod.object({
  "end_date": zod.string().optional(),
  "include_contract": zod.boolean().optional(),
  "portfolios": zod.array(zod.string()).optional(),
  "start_date": zod.string().optional()
})

export const PortfoliosPendingDataRetrieveResponse = zod.object({
  "totalProperties": zod.number(),
  "items": zod.array(zod.object({
  "propertyId": zod.string().optional(),
  "propertyName": zod.string().optional(),
  "serviceProviderId": zod.string().optional(),
  "serviceProviderName": zod.string().optional(),
  "portfolioId": zod.string(),
  "portfolioName": zod.string(),
  "hasTicketsInRange": zod.boolean()
}).strict())
}).strict()

